import { render } from "./ListDataCutiTidakSetuju.vue?vue&type=template&id=0d803e26"
import script from "./ListDataCutiTidakSetuju.vue?vue&type=script&lang=js"
export * from "./ListDataCutiTidakSetuju.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__